import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

import Tag from '@/atoms/Tag/Tag'
import excludeBlankKeys from '@/helpers/excludeBlankKeys'
import usePriceRange from '@/hooks/usePriceRange'

function PriceTags() {
  const { t } = useTranslation('products')
  const router = useRouter()

  const priceRange = usePriceRange()
  const priceTags = Object.keys(excludeBlankKeys(priceRange))

  const remove = (key: string) => {
    const query = excludeBlankKeys<string>({ ...router.query, [key]: null })
    router.push({ query }, undefined, { shallow: true })
  }

  return (
    <>
      {priceTags.map((tag) => {
        const price = `${priceRange[tag]}`
        const value = `${t(tag, { price })}`
        return <Tag key={tag} value={value} onRemove={() => remove(tag)} />
      })}
    </>
  )
}

export default PriceTags
